import { Navigate, Route, Routes } from 'react-router-dom'
import { StocksPage } from './features/stocks/StocksPage'
import { NotFoundPage } from './features/stocks/components/NotFoundPage'
import { AdminPage } from './features/admin/AdminPage'
import { ApiDocsPage } from './features/api-docs/ApiDocsPage'

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/stocks" replace />} />
      <Route path="/stocks" element={<StocksPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/api-docs" element={<ApiDocsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
